import Column from '@components/column'
import CardHeading from '@commons/headings/card'
import Empty from '@commons/empty'
import { Fragment, useEffect } from 'react'
import { Appointment } from '@apis'
import { useSelector } from 'react-redux'
import { format } from 'date-fns'
import {
  StyleConsultDateCard,
  StyleReportItem,
  StyleReportWrapper,
} from './style'
import Row from '@components/row'
import Image from '@components/image'
import Typography from '@components/typography'
import Button from '@components/button'
const AppointmentConsultReport = ({ patientId, id, doctorId }: any) => {
  const { data: pastReports } = useSelector((state: any) => state.pastReports)
  const { data: user } = useSelector((state: any) => state.user)
  const fetchData = async () => {
    const params: any = {
      userId: patientId,
      appointmentId: id,
    }
    if (user?.role != 'doctor') {
      params.doctorId = doctorId
    }
    await Appointment.pastReports({
      params,
    }).catch(() => {})
  }

  const handleClickReport = (event) => {
    const urls = event.target.closest('[data-cross-url]')
    if (!!urls) {
      const url = urls.getAttribute('data-cross-url')
      window.open(url, '_blank')
    }
  }

  useEffect(() => {
    if (!pastReports?.length) {
      fetchData()
    }
  }, [])

  return (
    <Column
      bg="white"
      styleColumn="padding:20px;border-radius:12px;"
      rowGap={15}
    >
      <CardHeading title="Past Consult Report" tc="primary" />
      {!!pastReports?.length ? (
        <StyleReportWrapper onClick={handleClickReport}>
          {pastReports?.map((report: any) => {
            return (
              <Fragment key={report?.id}>
                <StyleReportItem>
                  <Row colGap={10}>
                    <Image
                      src={`${process.env.BUCKET_URL}/${report?.appointmentWith?.avatar}`}
                    />
                    <Column rowGap={10}>
                      <Typography
                        content={report?.appointmentWith?.name}
                        size={14}
                        tc="text100"
                      />
                      <StyleConsultDateCard>
                        <Typography
                          content={`Consulted On:${format(report?.date, 'dd MMM, yyyy')}`}
                          size={12}
                          tc="primary"
                        />
                      </StyleConsultDateCard>
                    </Column>
                  </Row>
                  <Button
                    data-cross-url={report?.report}
                    title="View Report"
                    outline
                    styleButton="padding:0px 10px"
                  />
                </StyleReportItem>
              </Fragment>
            )
          })}
        </StyleReportWrapper>
      ) : (
        <Empty />
      )}
    </Column>
  )
}

export default AppointmentConsultReport
